import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiURL } from '../config';

function ConfigEditor() {
  const [config, setConfig] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [pm2List, setPm2List] = useState('');
  const [restartCommand, setRestartCommand] = useState('');

  useEffect(() => {
    fetchConfig();
    fetchPm2List();
  }, []);

  const fetchConfig = async () => {
    const response = await axios.get(`${apiURL}/api/config`);
    setConfig(response.data);
  };

  const fetchPm2List = async () => {
    const response = await axios.get(`${apiURL}/api/pm2-list`);
    setPm2List(response.data.output);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateJson()) {
      try {
        await axios.post(`${apiURL}/api/config/update`, { config }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        alert('Config updated successfully.');
      } catch (error) {
        console.error('Error updating config:', error);
        alert(`Failed to update config: ${error.message}`);
      }
    }
  };

  const handleChange = (e) => {
    setConfig(e.target.value);
  };

  const validateJson = () => {
    try {
      const configText = config.trim();
      const firstBrace = configText.indexOf('{');
      const lastBrace = configText.lastIndexOf('}');
      if (firstBrace === -1 || lastBrace === -1 || firstBrace >= lastBrace) {
        throw new Error('Invalid config structure');
      }
      const jsonContent = configText.substring(firstBrace, lastBrace + 1);
      // eslint-disable-next-line no-new-func
      const getParsedConfig = new Function('return ' + jsonContent);
      const parsedConfig = getParsedConfig();
      console.log(parsedConfig);
      setIsValid(true);
      alert('Config is valid');
      return true;
    } catch (error) {
      setIsValid(false);
      alert('Invalid config: ' + error.message);
      return false;
    }
  };

  const handleRestart = async () => {
    if (!restartCommand) {
      alert('Please enter a restart command');
      return;
    }
    try {
      const response = await axios.post(`${apiURL}/api/restart`, { command: restartCommand });
      alert(`Restart command executed. Output: ${response.data.output}`);
    } catch (error) {
      console.error('Error restarting:', error);
      alert(`Failed to restart: ${error.message}`);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8 bg-white">
      <h1 className="text-3xl font-bold mb-6">Config Editor</h1>
      <form onSubmit={handleSubmit} className="mb-8">
        <textarea
          value={config}
          onChange={handleChange}
          rows={30}
          className="w-full p-2 border border-gray-300 rounded-md mb-4 font-mono text-sm"
        />
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={validateJson}
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          >
            Validate
          </button>
          <button
            type="submit"
            disabled={!isValid}
            className={`${
              isValid
                ? 'bg-green-500 hover:bg-green-600'
                : 'bg-gray-400 cursor-not-allowed'
            } text-white font-bold py-2 px-4 rounded`}
          >
            Update Config
          </button>
        </div>
      </form>
      
      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-2">PM2 Process List:</h3>
        <pre className="bg-gray-100 p-4 rounded-md overflow-x-auto">{pm2List}</pre>
      </div>
      
      <div className="flex items-center space-x-4">
        <input
          type="text"
          value={restartCommand}
          onChange={(e) => setRestartCommand(e.target.value)}
          placeholder="Enter restart command (e.g., pm2 restart app-name)"
          className="flex-grow p-2 border border-gray-300 rounded-md"
        />
        <button
          onClick={handleRestart}
          className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded"
        >
          Execute Restart Command
        </button>
      </div>
    </div>
  );
}

export default ConfigEditor;